<template>
  <div>
        <!-- Sidebar -->
        <div class="col-sm-12">
          <b-card class="mx-2">
            
            <b-container>
              <b-row>
                <b-col md="6">
                 
                    <span class="mb-1"> Campaign Status Colors </span>
                    <div>
                      <b-badge style="background-color: #28a745; color: white;" class="mr-1">Completed</b-badge>
                      <b-badge style="background-color: #4A7CBD; color: white;" class="mr-1">In Progress</b-badge>
                      <b-badge style="background-color: #ffc107; color: black;" class="mr-1">Draft</b-badge>
                      <b-badge style="background-color: #dc3545; color: white;" class="mr-1">Cancelled</b-badge>
                    </div>
                
                </b-col>
                
                <b-col md="6">
                 
                    <span class="mb-1" > Content Status Colors </span>
                    <div>
                      <b-badge style="background-color: #ffc107; color: black;" class="mr-1">Scheduled Content</b-badge>
                      <b-badge style="background-color: #28a745; color: white;" class="mr-1">Published Content</b-badge>
                      <b-badge style="background-color: #4A7CBD; color: white;" class="mr-1">Unpublished Content</b-badge>
                      <b-badge style="background-color: #dc3545; color: white;" class="mr-1">Cancelled Content</b-badge>
                    </div>
                 
                </b-col>
              </b-row>
            </b-container>
            
          </b-card>
        </div>
        <div class="col-sm-12">
          <b-card class="mx-2">
            <b-form-group label="Search Campaigns or Content:" label-for="searchQuery">
              <b-form-input
                id="searchQuery"
                v-model="searchQuery"
                placeholder="Search campaigns or content..."
                @input="filterCalendarEvents"
              ></b-form-input>
            </b-form-group>
            
            <div ref="ganttContainer" style="width: 100%; height: 600px;"></div>            
          </b-card>
        </div>
      </div>
</template>

<script>
import {
  BButton,
  BSidebar,
  BCard,
  BCardTitle,
  BBadge,
  BCardBody,
  BFormSelect,
  BRow,
  BCol,
  BContainer,
  BFormInput,
  BFormGroup,

} from "bootstrap-vue";
import FullCalendar from "@fullcalendar/vue";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import Sidebar from "./SidebarView.vue";
import VFacebookLogin from "vue-facebook-login-component";
import axios from "axios";
import { mapGetters, mapActions } from "vuex";
import gantt from "dhtmlx-gantt";
import "dhtmlx-gantt/codebase/dhtmlxgantt.css";
import dayjs from "dayjs";
export default {
  components: {
    FullCalendar,
    BButton,
    BSidebar,
    Sidebar,
    BBadge,
    BCardBody,
    BCard,
    BCardTitle,
    BFormSelect,
    VFacebookLogin,
    BRow,
    BCol,
    BContainer,
    BFormInput,
    BFormGroup
  },

  data() {
    return {
      searchQuery: "",
      calendarEvents: [],
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin],
        initialView: "dayGridMonth",
        events: [],
        editable: true,
        selectable: true,
        eventClick: () => {},
      },
      showSidebar: false,
      appId: "",
      name: "",
      beakerToken: localStorage.getItem("accessToken"),
      email: "",
      personalID: "",
      picture: "",
      fb: null,
      message: "",
      pageid: "",
      FB: {},
      model: {},
      scope: {},
      pagePost: [],
      facebookToken: "",
      scheduled: [],
      userId: {},
      connected: false,
      selectedItem: [],
      selectedSocialMedia: "facebook",
      socialMediaOptions: [
        { value: "facebook", text: "Facebook" },
        { value: "instagram", text: "Instagram" },
        { value: "linkedin", text: "LinkedIn" },
      ],
      ganttTasks: [],
      ganttLinks: [],
    };
  },
  computed: {
    ...mapGetters("marketingModule", {
      appid: "appid",
      marketingPlan: "marketingPlan",
      loadingMarketing: "loading",
    }),
  },
  async mounted() {
  try {
    const loader = this.$swal.fire({
      title: 'Processing...',
      text: 'Please wait while the data is being fetched',
      didOpen: () => {
        this.$swal.showLoading();
      },
      allowOutsideClick: () => !this.$swal.isLoading(),
      buttonsStyling: false,
      showConfirmButton: false,
    });

    await this.getMarketingPlanAction();
    this.transformData();
    this.renderGantt();

    // ✅ Save the original list before filtering
    this.allGanttTasks = [...this.ganttTasks.data];

    loader.close();
  } catch (error) {
    console.log(error);
    loader.close();
  }
},
  methods: {
    ...mapActions("marketingModule", ["getAppIdAction", "getMarketingPlanAction"]),
    handleEventClick(clickInfo) {
      window.open(clickInfo.event._def.extendedProps.link, "_blank");
    },

    getDraftColor(draft) {
      if (draft.scheduledPublishedDate) {
    return "#F1C40F"; // Yellow
} else if (draft.publishedDate) {
    return "#28a745"; // Green
} else {
    return "#4A7CBD"; // Blue
}
  },
  filterCalendarEvents() {
  if (!this.searchQuery) {
    // ✅ Restore all tasks when search is cleared
    this.ganttTasks.data = [...this.allGanttTasks];
  } else {
    const searchTerm = this.searchQuery.toLowerCase();

    // ✅ Ensure backup exists before filtering
    if (this.allGanttTasks) {
      this.ganttTasks.data = this.allGanttTasks.filter(task => {
        const isMatch = task.text.toLowerCase().includes(searchTerm);

        // ✅ If it's a campaign, also include its linked content
        if (isMatch && !task.parent) {
          return true; // Campaigns match directly
        }

        // ✅ If it's a content item, also include the campaign
        if (isMatch && task.parent) {
          return true; // Matched content should be shown
        }

        // ✅ If campaign is linked to searched content, include it
        const isParentMatch = this.allGanttTasks.some(t => 
          t.id === task.parent && t.text.toLowerCase().includes(searchTerm)
        );

        return isParentMatch;
      });
    }
  }

  // ✅ Update the Gantt chart with filtered results
  this.updateGanttChart();
},
    handleSdkInit({ FB, scope }) {
      this.FB = FB;
      this.scope = scope;
    },
    onLogin(response) {
      console.log(response);
      this.FB.api(
        "/me/accounts",
        "GET",
        { fields: "name,access_token" },
        (data) => {
          this.facebookToken = data.data[0].access_token;
          this.connected = true;
          localStorage.setItem("facebookToken", this.facebookToken);
          console.log(data);

          if (this.facebookToken) {
            // this.getPosts();
            this.getSchedules();
          }
        }
      );
      this.FB.api("/me", "GET", { fields: "name" }, (data) => {
        this.userId = data;
      });
    },
    getAppId() {
      let config = {
        headers: {
          Authorization: "Bearer " + this.token,
        },
      };
      const url = process.env.VUE_APP_API_URLv1;
      axios.get(url + "marketings/facebook/requestappid", config).then((res) => {
        this.appId = res.data.result.token;
      });
    },
    getPosts() {
      let token = this.facebookToken;
      let access_token = this.beakerToken;
      this.loading = true;
      console.log(token);
      axios.defaults.headers.common["Authorization"] = "Bearer " + access_token;
      const url = process.env.VUE_APP_API_URLv1;
      axios
        .get(url + "marketings/facebook/getpagepost?token=" + token)
        .then((res) => {
          this.pagePost = res.data.result.data;
          for (let i = 0; i < this.pagePost.length; i++) {
            this.scheduled.push(this.pagePost[i]);
          }
        });
    },

    transformData() {
  let data = [];
  let links = [];

  this.marketingPlan.forEach((campaign) => {
    let backgroundColor;
    switch (campaign.status) {
      case "COMPLETED":
        backgroundColor = "#28a745";
        break;
      case "INPROGRESS":
        backgroundColor = "#4A7CBD";
        break;
      case "DRAFT":
        backgroundColor = "#ffc107";
        break;
      case "CANCELLED":
        backgroundColor = "#dc3545";
        break;
      default:
        backgroundColor = "#007bff";
    }

    data.push({
      id: campaign.id,
      text: `Campaign: ${campaign.name}`,
      start_date: dayjs(campaign.startDate).format("DD-MM-YYYY"),
      duration: (dayjs(campaign.endDate).diff(dayjs(campaign.startDate), "days") + 1) || 1, //to cater for end of day add 1
      progress: 1,
      open: true,
      color: backgroundColor,
      status: campaign.status, // ✅ Add status field
    });

    if (campaign.campaignDrafts && campaign.campaignDrafts.length) {
      campaign.campaignDrafts.forEach((draft) => {
        let backgroundColorContent;
        switch (draft.status) {
          case "SCHEDULED":
            backgroundColorContent = "#dc3545";
            break;
          case "PUBLISHED":
            backgroundColorContent = "#28a745";
            break;
          case "DRAFT":
            backgroundColorContent = "#4A7CBD";
            break;
          case "CANCELLED":
            backgroundColorContent = "#007bff";
            break;
          default:
            backgroundColorContent = "#4A7CBD";
        }

        data.push({
          id: draft.id,
          text: draft.name && draft.name.trim() !== "" ? draft.name : "Untitled Content",
          start_date: draft.startDate && draft.startDate !== "0001-01-01T00:00:00" 
            ? dayjs(draft.startDate).format("DD-MM-YYYY") 
            : dayjs(campaign.startDate).format("DD-MM-YYYY"),
          duration: draft.endDate && draft.endDate !== "0001-01-01T00:00:00" 
            ? dayjs(draft.endDate).diff(dayjs(draft.startDate), "days") || 1 
            : 1,
          progress: Math.random(),
          parent: campaign.id,
          assignee: draft.assigneeName || "Unassigned",
          color: backgroundColorContent,
          status: draft.status, // ✅ Ensure status is included
          contentPostLink: draft.contentPostLink || null, // ✅ Store content post link
        });

        links.push({
          id: `link-${draft.id}`,
          source: campaign.id,
          target: draft.id,
          type: "1", // Defines the parent-child relationship
        });
      });
    }
  });

  this.ganttTasks = { data };
  this.ganttLinks = { links };
}
,
handleEventDblClick(taskId) {
  const selectedItem = gantt.getTask(taskId); // ✅ Fetch task from Gantt
  console.log('Selected Item:', selectedItem);

  if (!selectedItem) return;

  if (!selectedItem.parent) {
    // ✅ Campaign clicked
    if (selectedItem.status === "COMPLETED" || selectedItem.status === "CANCELLED" ) {
    this.$swal.fire({
      title: "Go to Campaign?",
      text: "Do you want to view this campaign?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, view campaign",
      cancelButtonText: "No",
      customClass: {
        confirmButton: 'swal-confirm-btn',  // ✅ Apply custom spacing
        cancelButton: 'swal-cancel-btn'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.$router.push(`/marketing/campaign/view/${selectedItem.id}`);
      }
    });
  }else{ 
    this.$swal.fire({
      title: "Go to Campaign?",
      text: "Do you want to edit this campaign?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, edit campaign",
      cancelButtonText: "No",
      customClass: {
        confirmButton: 'swal-confirm-btn',  // ✅ Apply custom spacing
        cancelButton: 'swal-cancel-btn'
      }
    }).then((result) => {
      if (result.isConfirmed) {
        this.$router.push(`/marketing/campaign/edit/${selectedItem.id}`);
      }
    });
  }

  } else {
    // ✅ Content clicked
    if (selectedItem.status === "PUBLISHED" && selectedItem.contentPostLink) {
      this.$swal.fire({
        title: "Go to Published Post?",
        text: "This content is published. Do you want to view the post?",
        icon: "info",
        showCancelButton: true,
        confirmButtonText: "Yes, view post",
        cancelButtonText: "No",
        customClass: {
        confirmButton: 'swal-confirm-btn',  // ✅ Apply custom spacing
        cancelButton: 'swal-cancel-btn'
      }
      }).then((result) => {
        if (result.isConfirmed) {
          window.open(selectedItem.contentPostLink, "_blank");
        }
      });
    } else {
      this.$swal.fire({
        title: "Edit Content?",
        text: "Please go to campaign to edit this content",
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Go to campaign",
        cancelButtonText: "No",
        customClass: {
        confirmButton: 'swal-confirm-btn',  // ✅ Apply custom spacing
        cancelButton: 'swal-cancel-btn'
      }
      }).then((result) => {
        if (result.isConfirmed) {
          this.$router.push(`/marketing/campaign/edit/${selectedItem.parent}`);
        }
      });
    }
  }
}
,
renderGantt() {
  this.$nextTick(() => {
    gantt.config.readonly = true;
    gantt.config.drag_move = false;
    gantt.config.drag_resize = false;
    gantt.config.drag_progress = false;
    gantt.config.show_task_cells = false;
    gantt.config.grid_resize = true;
    gantt.config.buttons_left = [];
    gantt.config.buttons_right = [];
    gantt.config.add_task = false;
    gantt.config.grid_resizer = true;


    // ✅ Configure the Gantt Chart to Show Year and Dates Properly
    gantt.config.scale_unit = "month"; // Display months on top
    gantt.config.date_scale = "%F %Y"; // Month and Year (e.g., "March 2024")
    gantt.config.subscales = [
      { unit: "day", step: 1, date: "%j %D" } // Day with abbreviation (e.g., "3 Wed")
    ];

    gantt.config.columns = [
      { name: "text", label: "Campaign", tree: true, width: 250, resize: true },
    ];

    gantt.templates.task_class = function (start, end, task) {
      return task.color ? `gantt_task_line_${task.color.replace("#", "")}` : "";
    };

    gantt.init(this.$refs.ganttContainer);
    gantt.clearAll();

    gantt.parse({ data: this.ganttTasks.data, links: this.ganttLinks.links });

    // ✅ Auto-scroll to today's date WITHOUT filtering any data
    setTimeout(() => {
      gantt.showDate(new Date()); // Scroll to today's date
    }, 500);

    gantt.attachEvent("onTaskDblClick", (id, e) => {
      this.handleEventDblClick(id);
      return false;
    });
  });
},
    updateGanttChart() {
  this.$nextTick(() => {
    gantt.clearAll(); // ✅ Clear previous tasks

    gantt.parse({ data: this.ganttTasks.data, links: this.ganttLinks.links }); // ✅ Reload filtered tasks
  });



}
  },
  handleEventClick(clickInfo) {
    this.showSidebar = !this.showSidebar;
    this.selectedItem = clickInfo.event;
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/apps/calendar.scss";
</style>

<style>
.fc .fc-col-header-cell-cushion {
  display: inline-block;
  padding: 2px 4px;
}

.dark-layout .bg-instagram {
  background-color: #8134AF;
}

.btn-instagram {
  background-color: #DD2A7B;
}

.dark-layout .bg-linkedin {
  background-color: #0a66c2;
}

.btn.btn-black {
  background-color: #000000;
}
.gantt_task_line_28a745 {
  background: #28a745 !important;
  border: 1px solid #1e7e34 !important;
}
.gantt_task_line_4A7CBD {
  background: #4A7CBD !important;
  border: 1px solid #3a5a98 !important;
}
.gantt_task_line_ffc107 {
  background: #ffc107 !important;
  border: 1px solid #d39e00 !important;
}
.gantt_task_line_dc3545 {
  background: #dc3545 !important;
  border: 1px solid #b21f2d !important;
}
/* ✅ Add spacing between Swal buttons */
.swal-confirm-btn {
  margin-right: 15px !important; /* Adjust spacing */
}
.swal-cancel-btn {
  margin-left: 15px !important;
}
</style>
